import type { ExplanationChatPathBuilder } from "@/payroll/ai-script/types";

export const getAiScriptExplanationChatPath: ExplanationChatPathBuilder = (
  businessId,
  runId,
) => `/businesses/${businessId}/ai_script_runs/${runId}/explanation_chat`;

export const getAiScriptSpreadsheetPath = (businessId: string, runId: string) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/spreadsheet`;

export const getAiScriptStatementPath = (businessId: string, runId: string) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/spreadsheet/statement`;

export const getAiScriptTechnicianStatementPath = (
  businessId: string,
  runId: string,
  technicianId: string,
) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/spreadsheet/statements/${technicianId}`;

export const getAiScriptSpreadsheetCellPath = (
  businessId: string,
  runId: string,
  cellId: string,
) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/spreadsheet/cells/${cellId}`;

export const getAiScriptSpreadsheetPastePath = (
  businessId: string,
  runId: string,
) => `/businesses/${businessId}/ai_script_runs/${runId}/spreadsheet/paste`;

export const getAiScriptSpreadsheetRegionsPath = (
  businessId: string,
  runId: string,
  sheetId: string,
) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/spreadsheet/sheets/${sheetId}/regions`;

export const getAiScriptSpreadsheetRegionPath = (
  businessId: string,
  runId: string,
  sheetId: string,
  regionId: string,
) =>
  `${getAiScriptSpreadsheetRegionsPath(businessId, runId, sheetId)}/${regionId}`;

export const getAiScriptSpreadsheetRegionOverrideConfirmPath = (
  businessId: string,
  runId: string,
  overrideId: string,
) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/spreadsheet/region_overrides/${overrideId}/confirm`;

export const getAiScriptCellOverridesPath = (
  businessId: string,
  runId: string,
) => `/businesses/${businessId}/ai_script_runs/${runId}/cell_overrides`;

export const getAiScriptManualRowsPath = (businessId: string, runId: string) =>
  `/businesses/${businessId}/ai_script_runs/${runId}/manual_rows`;
